window.addEventListener('load', () => {
    const videos = document.querySelectorAll('video[autoplay]');

    videos.forEach(video => {
        if (!video) return;

        // Ensure video is muted to increase autoplay compatibility
        if (!video.muted) {
            video.muted = true;
        }

        // Try to autoplay
        video.play().catch(() => {
            // Autoplay failed, wait for first user interaction
            const tryPlay = () => {
                video.play().catch(err => {
                    console.warn('Video failed to play on user interaction:', err);
                });

                // Clean up after first attempt
                cleanup();
            };

            const cleanup = () => {
                document.removeEventListener('click', tryPlay);
                document.removeEventListener('touchstart', tryPlay);
            };

            document.addEventListener('click', tryPlay, { once: true });
            document.addEventListener('touchstart', tryPlay, { once: true });
        });
    });
});
